import styled from 'styled-components';

import { borderGradientStyle } from '@sorare/core/src/style/utils';

import { ColorLevelTreshold } from './utils';

export const gradientLevels: Record<ColorLevelTreshold, string> = {
  0: 'linear-gradient(315deg, #cecaca 14.64%, #8d8989 85.36%)',
  10: 'linear-gradient(323deg, #AE5E13 14.3%, #DFAD46 85.7%)',
  20: 'linear-gradient(323deg, #C22342 14.3%, #F2412D 85.7%)',
  30: 'linear-gradient(323deg, #366BF2 14.3%, #6B49DB 85.7%)',
  40: 'linear-gradient(84.1deg, #F8D3DA 0%, #B3A9F4 28.32%, #FBE9FB 54.01%, #4F94FD 100%)',
};

export const ManagerIdRoot = styled.div`
  position: relative;
  padding: 1px;
  background-color: var(--c-nd-100-opaque);

  --border-size: 1px;
  --border-gradient: var(--border);
  ${borderGradientStyle}
`;
